import 'babel-polyfill';
import App from './App';
import configureStore from './store/configureStore';
import * as serviceWorker from './serviceWorker';
import { MODE } from './constants';
import './index.css';

import { Router, Route, Switch } from 'react-router-dom';
import ReactDOM from 'react-dom';
import React from 'react';
import { createBrowserHistory } from 'history';
import { invoke } from 'lodash';
import 'semantic-ui-css-offline';

console.log('Nosturi version %s loading...', process.env.REACT_APP_VERSION);

const history = createBrowserHistory();

const rootElement = document.getElementById('root');
const appRef = React.createRef();

const renderApp = (ref, history, callback) => {
  const createAppMode = mode => {
    return class extends React.Component {
      state = configureStore(mode);
      render() {
        const route = this.props;
        const { store } = this.state;
        return <App ref={ref} {...{ mode, store, route }} />;
      }
    };
  };

  const ConnectedApp = createAppMode(MODE.CONNECT);
  //const SharingApp = createAppMode(MODE.SHARE);
  const OfflineApp = createAppMode(MODE.OFFLINE);

  ReactDOM.render(
    <Router history={history}>
      <Switch>
        <Route path="/connect/:roomKey" component={ConnectedApp} />
        {/*<Route path="/share/:eventId" component={SharingApp} />*/}
        <Route component={OfflineApp} />
      </Switch>
    </Router>,
    rootElement,
    callback,
  );
};

renderApp(appRef, history);

serviceWorker.register({
  onoffline: () => {
    invoke(appRef.current, 'onServiceWorkerOffline');
  },
  onupdateinstalled: () => {
    invoke(appRef.current, 'onServiceWorkerUpdateInstalled');
  },
  onerror: error => () => {
    invoke(appRef.current, 'onServiceWorkerError');
  },
});

if (process.env.NODE_ENV !== 'production' && module.hot) {
  console.warn('HMR: Hot module replacement enabled for app interface!');
  module.hot.accept('./App', () => {
    renderApp(appRef, history, () => {
      console.warn('HMR: App interface was hot reloaded from server!');
    });
  });
}



// WEBPACK FOOTER //
// ./src/index.js